import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { WorkersService } from 'src/app/modules/workers/_services/workers.service';
import { WorkerRate } from '../../_types/worker-rate';
import { WorkerRatesService } from '../../_services/workers-rates.service';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-rate-worker',
    templateUrl: './rate-worker.component.html',
    styleUrls: ['./rate-worker.component.scss'],
    standalone: false
})
export class RateWorkerComponent {
  
  public rateWorkerFormGroup!: RxFormGroup;

  public rateWorker: WorkerRate = new WorkerRate();
  public workers: any[] = [];  

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;


  constructor(
    private workerRatesService: WorkerRatesService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private workersService: WorkersService,
    private loginService: LoginService
  ) {
    this.rateWorkerFormGroup = this.formBuilder.formGroup<WorkerRate>(this.rateWorker) as RxFormGroup;
  }

  ngOnInit(): void {
    if (this.config.data.rateWorkerId) {
      this.loadRateWorker(this.config.data.rateWorkerId);            
    } else {
      this.rateWorker.rateId = this.config.data.rateId;
    }
    this.loadWorkers();

    this.allowWrite = this.loginService.hasPermission('WORKER_RATES.WRITE');
    this.allowDelete = this.loginService.hasPermission('WORKER_RATES.DELETE');
  }

  async loadRateWorker(id: string) {
    this.rateWorker = await firstValueFrom(this.workerRatesService.get(id));    
    this.rateWorkerFormGroup.patchValue(this.rateWorker);    
  }

  async loadWorkers() {
    let response = await firstValueFrom(this.workersService.all());

    this.workers = response.data;
  }  


  async save() {    
    let valid = this.formValidationService.validateForm(this.rateWorkerFormGroup);
    if (valid) {
      this.rateWorker = Object.assign(this.rateWorker, this.rateWorkerFormGroup.value);
                  
      await this.workerRatesService.save(this.rateWorker).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Operario asignado correctamente' });
          this.dynamicDialogRef.close();
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al asignar el operario' });
        }
      });
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea desasignar el operario?",
      header: "Desasignar operario",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerRatesService.delete(this.rateWorker.id).subscribe({
          next: () => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Operario desasignado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }
}
